import constants from "../constants";

const { UPDATE_PROJECTS, REMOVE_PROJECTS } = constants;

const initialState = {};

export default (state = initialState, action) => {
  if (!action) return state;
  const { type } = action;
  switch (type) {
    case UPDATE_PROJECTS:
      return { ...action.data };
    case REMOVE_PROJECTS:
      return {};
    default:
      return state;
  }
};
